import { get, writable } from 'svelte/store';
import { OwnershipService } from '../../services/ownership.service';
export const loading = writable(false);
export const editing = writable(false);
export const records = writable([]);
export const record = writable(null);
let initialized = false;
export async function init() {
    if (!initialized) {
        initialized = true;
        editing.set(false);
        records.set([]);
        record.set(null);
    }
    await reloadOwnerships();
}
export async function loadOwnerships() {
    let data = await OwnershipService.fetchOwnerships().toPromise();
    records.set(data.payload);
}
export async function reloadOwnerships() {
    loadOwnerships();
}
export function onCreate() {
    let item = {
        oid: 0,
        name: '',
        regionId: 0
    };
    record.set(item);
    editing.set(true);
}
export function onEdit(item) {
    record.set(Object.assign({}, item));
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    await OwnershipService.saveOwnership(_record).toPromise();
    await reloadOwnerships();
}
